import { KeycloakWrapperService } from '../../../../lib/services/keycloak-wrapper-service/keycloak-wrapper.service';
import { SocketService } from '../../../../lib/services/socket-service/socket-service.service';

export function logoutAndDisconnectWebSockets(
  socketService: SocketService,
  keycloakService: KeycloakWrapperService,
): void {
  socketService.disconnect();
  keycloakService.logout();
}
